<ion-header>
  <ion-toolbar color="gallaghergreen">
    <img class="gallagher-logo" [src]="'./assets/images/Gallagher Logo -White Transparent.png'" />
  </ion-toolbar>
</ion-header>
<ion-content class="login-content">

  <div class="parent-container">
    <ion-card [ngClass]="{'larger-width': authService.isNative}" *ngIf="!isQRCode">
      <ion-card-header>
        <!-- Warning Message -->
        <div class="service-warning" *ngIf="isServiceOffline">
          ⚠️ Unable to connect to the WebService.
        </div>
        <span class="login-title">Log In</span>
      </ion-card-header>
      <ion-grid>
        <div class="loading-container" *ngIf="!loaded">
          <ion-spinner></ion-spinner>
        </div>
        <ion-row class="sign-in-options" *ngIf="!authService.isNative && showOptionsBar">
          <ion-col [ngClass]="{'selected': loginMode === LoginMode.Gtrak}" (click)="changeLoginForm(LoginMode.Gtrak)">
            User Id / Password
          </ion-col>
          <ion-col [ngClass]="{'selected': loginMode === LoginMode.Gmobile}"
            (click)="changeLoginForm(LoginMode.Gmobile)">
            Locker # / Stop #
          </ion-col>
          <ion-col [ngClass]="{'selected': loginMode === LoginMode.Groute}" (click)="changeLoginForm(LoginMode.Groute)">
            G-route
          </ion-col>
        </ion-row>
        <div *ngIf="(loginMode === LoginMode.Gtrak) || (loginMode === LoginMode.Gmobile)">
          <ion-row>
            <ion-col>
              <ion-label>User Id</ion-label>
              <ion-input autocapitalize="none" autocomplete="email" type="text" [(ngModel)]="creds.login"
                placeholder="Enter your user id" class="ion-text-left color-light user-id"></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label>Password</ion-label>
              <app-show-hide-password>
                <ion-input type="password" autocomplete="password" autocapitalize="none" [(ngModel)]="creds.password"
                  placeholder="Enter your password" class="ion-text-left color-light"></ion-input>
              </app-show-hide-password>
            </ion-col>
          </ion-row>
        </div>
        <div *ngIf="loginMode === LoginMode.GWearer">
          <ion-row>
            <ion-col>
              <ion-label>Stop #</ion-label>
              <ion-input type="text" [(ngModel)]="creds.stopCode" placeholder="Enter your stop #"
                class="ion-text-left color-light user-id"></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label>Locker #</ion-label>
              <ion-input type="text" [(ngModel)]="creds.lockerNum" placeholder="Enter your locker #"
                class="ion-text-left color-light user-id"></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label>Last Name</ion-label>
              <ion-input type="text" [(ngModel)]="creds.lastName" placeholder="Enter your last name"
                class="ion-text-left color-light user-id"></ion-input>
            </ion-col>
          </ion-row>
        </div>
        <div *ngIf="loginMode === LoginMode.Groute">
          <ion-row>
            <ion-col>
              <ion-label>User Id</ion-label>
              <ion-input autocapitalize="none" autocomplete="email" type="text" [(ngModel)]="creds.login"
                placeholder="Enter your user id" class="ion-text-left color-light user-id"></ion-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label>Password</ion-label>
              <app-show-hide-password>
                <ion-input type="password" autocomplete="password" autocapitalize="none" [(ngModel)]="creds.password"
                  placeholder="Enter your password" class="ion-text-left color-light"></ion-input>
              </app-show-hide-password>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label><span>Routes</span></ion-label>
              <ion-select interface="popover" placeholder="Select a Route" (ionChange)="selectRoute($event)"
                [interfaceOptions]="{size: 'cover'}">
                <ion-select-option *ngFor="let route of routeList"
                  [value]="route.routeCode">{{route.description}}</ion-select-option>
              </ion-select>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-label>For Date</ion-label>
              <ion-input type="Date" [(ngModel)]="creds.routeDate"
                class="ion-text-left color-light user-id"></ion-input>
            </ion-col>
          </ion-row>
        </div>
        <ion-row>
          <ion-col>
            <ion-button color="gallaghergreen" class="btn-box-shadow submit-button" (click)="submit()"><span>Log
                in</span></ion-button>
          </ion-col>
        </ion-row>

        <!-- <ion-row *ngIf="(loginMode === LoginMode.Gmobile)" class="forgot-password">
          <ion-col>
            <span (click)="navigateToForgotPassword()">Forgot password?</span>
          </ion-col>
           
        </ion-row> -->


        <ion-row *ngIf="(loginMode === LoginMode.Gtrak) || (loginMode === LoginMode.GWearer)"
          class="garment-label-button">
          <ion-col class="register-text">
            <span (click)="navigateToQRCode()">QR Code- Garment Repair Request</span>
          </ion-col>
          <ion-col></ion-col>
          <ion-col class="garment-label-data-col" size="auto" class="register-text">
            <span *ngIf="(loginMode === LoginMode.Gtrak)" (click)="changeLoginForm(LoginMode.GWearer)">Log in with
              garment label</span>
            <span *ngIf="(loginMode === LoginMode.GWearer)" (click)="changeLoginForm(LoginMode.Gtrak)">Log in with
              Username/Password</span>
          </ion-col>


        </ion-row>
        <ion-row style="float:right">
          <!-- <ion-col  *ngIf="(loginMode === LoginMode.Gtrak)">
            <span (click)="navigateToQRCode()"  style="color: #1e90ff; text-decoration: underline; cursor: pointer;">QR Code- Garment Repair Request</span>
          </ion-col> -->
        </ion-row>
        <ion-row class="garment-label-button">
          <ion-col class="register-text"> <span (click)="navigateToForgotPassword()">Forgot password?</span></ion-col>
          <ion-col class="new-to-gtrak" size="auto">
            <span>New to G-Trak?</span>
          </ion-col>
          <ion-col (click)="navigateToCreateAccount()" class="register-text" size="auto">
            <span>Register Here</span>
          </ion-col>
          <ion-col></ion-col>
        </ion-row>
      </ion-grid>
    </ion-card>
    <ion-card *ngIf="isQRCode">
      <ion-row class="action-row">
        <ion-col size="3" class="left-btn">
          <ion-button fill="clear" class="print-link" (click)="printPage()">
            <ion-icon name="print-outline" slot="start"></ion-icon>
            Print
          </ion-button>
        </ion-col>
        <ion-col style="text-align: center;">
          <h2>
            Repair Request QR Code
          </h2>
        </ion-col>

        <ion-col size="3" class="right-btn">
          <ion-button fill="clear" class="print-link" (click)="scanBarCode()">
            Scan Barcode
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col></ion-col>
        <ion-col>
          <div class="qr-wrapper">
            <qrcode [qrdata]="QRCodeURL" [width]="180" errorCorrectionLevel="H">
            </qrcode>

            <img src="assets/images/20230130-gallagherUniform-logo-green-68x68.png" class="qr-logo" alt="Logo" />
          </div>
        </ion-col>
        <ion-col></ion-col>
      </ion-row>
      <ion-row>
        <ion-col></ion-col>
        <ion-col class="garment-label-data-col hidelogin" size="auto" class="register-text">
          <span (click)="changeLoginForm(LoginMode.Gtrak)"
            style="color:var(--ion-color-gallaghergreen);  text-decoration: underline;cursor: pointer;">Log in with
            Username/Password</span>
        </ion-col>
      </ion-row>
    </ion-card>
  </div>
</ion-content>